exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wrapper,.ba-app-content{height:auto!important;max-height:calc(100% - 80px)}.ba-app-content{overflow-y:hidden!important}#wrapper{overflow-y:scroll!important}.banner{position:absolute;width:100%;height:256px;margin:-1.8rem}.m-h{min-height:35rem}.route-icon{width:25px;height:25px}.d-none{display:none!important}*{font-family:Montserrat}@media (max-width:1430px){.m-h{width:calc(100vw - 32px - 228px - 54px)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ed6abc0","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/layouts/FranchiseLayout.vue
// module id = KsAc
// module chunks = 0